module.exports = __webpack_public_path__ + "img/Q.cfa134ce.webp";